<template>
    <div class="article-box" v-if="mp_url.length > 0" @click="openArticle">
        <van-image class="mp-icon" src="https://cdn-xcxcustom.weiyoubot.cn/20210610/fb62698897e2cecce16246ecd18ca39b.png" />
        <div class="mp-title">{{mp_title}}</div>
    </div>
</template>
<script>
export default {
   name: 'ArticleBox',
   props: {
       mp_icon: {
           type: String,
           default: ''
       },
       mp_url: {
           type: String,
           default: ''
       },
       mp_title: {
           type: String,
           default: ''
       }
   },
   methods: {
       openArticle() {
           window.open(this.mp_url)
       }
   }
}
</script>
<style lang="scss" scoped>
@function rem($px) {
   @return $px / 75 + rem;
}
.article-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: rem(120);
    border-radius: rem(8);
    background-color: #f2f2f7;
}
.mp-icon {
    width: rem(80);
    height: rem(80);
    margin-left: rem(16);
    border-radius: rem(8);
}
.mp-title {
    margin-left: rem(16);
    flex: 1;
    font-size: rem(26);
    color: #262626;
    max-width: 80%;
    overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/ArticleBox.vue